import { Box } from "@mui/material";
import React from "react";
import * as calFns from "../../../../components/Calendar/functions/calendarFunctions";
import Headers from "../Headers";
import DayBookList from "./DayBookList";
import useDayBook from "./hooks/useDayBook";
import Filters from "../Filters";
import useIsReactNativeWebView from "../../../../hooks/useIsReactNativeWebView";
import useMobileScreen from "../../../../hooks/useMobileScreen";

const DayBook = (): React.ReactNode => {
  const isMobileScreen = useMobileScreen();
  const { isRnWebView } = useIsReactNativeWebView();

  const [filters, setFilters] = React.useState({
    from: calFns.startOfDay(new Date()).toDate(),
    until: new Date()
  });

  const data = useDayBook(filters);

  const headers = [
    { key: "date", label: "Date" },
    { key: "voucherCode", label: "Voucher Code" },
    { key: "debitLedger", label: "Debit Ledger", className: "flex-1" },
    { key: "narration", label: "Narration" },
    { key: "entryAmt", label: "Entry Amt" }
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ p: 3 }}>
          <Filters filters={filters} setFilters={setFilters} />
        </Box>

        <Box
          sx={{
            borderTop: 1,
            borderColor: "divider"
          }}
        >
          <Headers headers={headers} />
        </Box>

        <Box
          className="dayBookReport"
          sx={{
            width: "100%",
            overflowX: "auto"
          }}
        >
          <Box sx={{ minWidth: isMobileScreen || isRnWebView ? "1200px" : "auto" }}>
            <DayBookList data={data} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DayBook;
